(function(){
    document.body.addEventListener('click', function(e) {
        if(e.target && e.target.closest('.currencies-toggle') && e.target.closest('.btn')) {
            var button = e.target.closest('.btn');
            var wrapper = button.closest('.price-wrapper');
            var buttons = e.target.closest('.currencies-toggle').querySelectorAll('.btn');
            var currency = button.getAttribute('data-currency');
            var prices = document.querySelectorAll('.prices-switchable .price');

            buttons.forEach(function(btn){
                btn.classList.remove('disabled');
                btn.removeAttribute('disabled');
            })
            button.classList.add('disabled');
            button.setAttribute('disabled', 'disabled');

            prices.forEach(function(price){
                if (price.classList.contains(currency)) {
                    price.classList.add('active');
                } else {
                    price.classList.remove('active');
                }
            })

            return false;
        }
    });
})();